export const getColorByPaymentStatusCode = (statusCode: string) => {
  switch (statusCode) {
    case 'P0100001':
      return '#838685'
    case 'P0100002':
      return '#8BD2D7'
    case 'P0100003':
      return '#fa6b6b'
    case 'P0100004':
      return '#fa6b6b'
    case 'P0100005':
      return 'fa6b6b'
    default:
      return '#838685'
  }
}
